import { render, staticRenderFns } from "./appointmentApply.vue?vue&type=template&id=5219b602&scoped=true&"
import script from "./appointmentApply.vue?vue&type=script&lang=js&"
export * from "./appointmentApply.vue?vue&type=script&lang=js&"
import style0 from "./appointmentApply.vue?vue&type=style&index=0&id=5219b602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5219b602",
  null
  
)

export default component.exports